import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const contactusRoute: RouteConfig<'with-page'> = {
    name: 'Error - Contact us',
    path: '/error/contactus',
    page: lazy(() => import('.')),
}